import type { PageContext } from "vike/types";
import type { ProductData } from "./+data";

export function title(pageContext: PageContext): string {
  const data = pageContext.data as ProductData | undefined;
  return data ? `${data.product.title} — OddStack Shop` : "OddStack Shop";
}
